/** アプリ内の主要ルート（ナビ・リダイレクト・パンくずで共通利用） */
export const PATIENTS_PATH = '/patients';
export const BOARD_MANUAL_PATH = '/board-manual';
export const BLOOD_TEST_PATH = '/blood-test';
